var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"report resource-list-item",class:{ 'is-dark': _vm.$themeDark },attrs:{"to":`/report/${_vm.report.uuid}`}},[_vm._v(" "+_vm._s(_vm.report.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }